import get from 'lodash/get';
import { getSRPPdfApi } from '@cores/apis/workspace_api/srp';
import $ from 'jquery';
export const onDownload = (patent, vm) => {
    const patentId = patent.PATENT_ID || patent.standard.PATENT_ID;
    const lang = get(patent, 'TITLE_LANG', '') || get(patent, 'standard.TITLE_LANG', '');
    getSRPPdfApi({
        patentId,
        lang,
    })
        .then(response => {
        const src = get(response, 'data.data.PDF_D', '');
        if (response.status === 200 && src) {
            let $iframe = $('<iframe>');
            $iframe
                .hide()
                .attr('src', src)
                .appendTo($(document.body));
            /**
             * Firefox 会触发 load 事件，但是如果此时删除 iframe，文件将不会被下载
             * Chrome 不会触发 load 事件
             * 由于以上情况，现在改为 1 分钟以后删除 iframe
             */
            setTimeout(() => {
                $iframe.remove();
                $iframe = null;
            }, 60 * 1000);
        }
        else {
            window.Bus.$emit('on-error-found', vm.$t('folder.labels.pdfNotExsit'));
        }
    })
        .catch(err => {
        window.Bus.$emit('on-error-found', err._error_msg);
    });
};
